import * as React from "react"

const Line5 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                id={"line-5"}
                width={826}
                height={446}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 826 446`}
            >


                <path
                    d="M428.5 1h-15.25M398 1h15.25m0 0v141c0 35.899 29.101 65 65 65H760c35.899 0 65 29.101 65 65v107.5c0 35.899-29.101 65-65 65H445.5"
                    stroke="#191822"
                />
                <path
                    ref={pathRef}
                    d="M398 1.5h15.25m15.25 0h-15.25m0 0v141c0 35.899-29.101 65-65 65H66.5c-35.898 0-65 29.101-65 65V380c0 35.899 29.102 65 65 65H381"
                    strokeDashoffset={props.normalizedPosition }
                    strokeDasharray={props.pathLength}
                    strokeWidth={2}
                    stroke="#DEDDE2"
                />
            </svg>
        )
    }
)
export default Line5;
